<mat-icon
  class="!p-0 !w-5 !h-5 cursor-pointer align-middle
  !text-[16px] leading-none"
  matTooltipClass="cus-primary-tooltip"
  [matTooltip]="tooltip" svgIcon="c:info-circle"></mat-icon>
<!-- <mat-icon  class="help-icon !p-0 !w-5 !h-5 !text-[16px] leading-none" matTooltipClass="cus-primary-tooltip" [matTooltip]="tooltip" svgIcon="c:info-circle"></mat-icon> -->
